import { assertRequestOwner, hasPlanCoverage } from './generation-request.js';

let nextRecovery = null;

function requestKey(requests) {
  return JSON.stringify(requests.map(({ billingMode, ...params }) => params));
}

/** A choice to review one exact failed tool action, never spending approval. */
export function choosePromptTokenRecovery(request, accountId) {
  assertRequestOwner(request, accountId);
  nextRecovery = { accountId, requestKey: requestKey(request.requests) };
}

export function clearPromptTokenRecovery(accountId) {
  if (nextRecovery && nextRecovery.accountId !== accountId) nextRecovery = null;
}

export function takePromptBillingMode({ accountId, requests, subscription }) {
  const recovery = nextRecovery;
  nextRecovery = null;
  if (recovery?.accountId === accountId && recovery.requestKey === requestKey(requests)) return 'tokens';
  return hasPlanCoverage(subscription) ? 'subscription' : 'tokens';
}
